<template>
  <div class="wary_list" @click="colseLayer()" id="clip_num">
    <van-pull-refresh v-model="isLoading_qj" @refresh="onRefresh">
    <van-sticky>
      <van-dropdown-menu class="list_menu">
        <van-dropdown-item :title="parameterType.time.info" ref="item_time" title-class="list_item" @close="closeItem({type:'item_time'})">
          <ul class="timeUl">
            <li :class="parameterType.time.val == '' ? 'hover':''" @click="screenList({type:'time',val:'',info:'全部时间'})">全部时间</li>
            <li :class="parameterType.time.val == '1day' ? 'hover':''" @click="screenList({type:'time',val:'1day',info:'今日'})">今日</li>
            <li :class="parameterType.time.val == '24hour' ? 'hover':''" @click="screenList({type:'time',val:'24hour',info:'24小时'})">24小时</li>
            <li :class="parameterType.time.val == '7day' ? 'hover':''" @click="screenList({type:'time',val:'7day',info:'7天'})">7天</li>
            <li :class="parameterType.time.val == '30day' ? 'hover':''" @click="screenList({type:'time',val:'30day',info:'30天'})">30天</li>
            <li :class="parameterType.time.val == 'zdy' ? 'hover':''" @click="showZdytime()">自定义</li>
          </ul>
        </van-dropdown-item>
        <van-dropdown-item title="媒体类型" ref="item_sourceType" title-class="list_item" @close="closeItem({type:'item_sourceType'})">
          <p class="pub_tit">媒体类型（多选）</p>
          <ul class="pub_Ul">
            <li :class="parameterType.sourceType.val == '' ? 'hover':''" @click="multipleChoice({type:'sourceType',val:'',info:'全部'})">全部</li>
            <li v-for="(source,s) of sourceType" v-bind:key="s" :class="(parameterType.sourceType.val.indexOf(source.sourceCode) > -1) ? 'hover' : ''" @click="multipleChoice({type:'sourceType',val:source.sourceCode,info:source.sourceName})" >{{source.sourceName}}</li>
          </ul>
          <div class="clearfix"></div>
          <div class="button_warys">
            <span @click="resetInfo({type:'sourceType'})">重置</span>
            <span @click="screenList({type:'sourceType',val:'',info:''})">确定</span>
          </div>
        </van-dropdown-item>
        <van-dropdown-item title="筛选" ref="item_screen" title-class="list_item" @close="closeItem({type:'screen'})">
          <p class="pub_tit">推送预警（多选）</p>
          <!--没有开通舆情研判-->
          <ul class="pub_Ul">
            <li :class="parameterType.warningType.val == '' ? 'hover':''" @click="multipleChoice({type:'warningType',val:'',info:'全部'})">全部</li>
            <li :class="(parameterType.warningType.val.indexOf('4') > -1) ? 'hover' : ''" @click="multipleChoice({type:'warningType',val:'4',info:'推送'})" >推送</li>
            <li :class="(parameterType.warningType.val.indexOf('3') > -1) ? 'hover' : ''" @click="multipleChoice({type:'warningType',val:'3',info:'手动预警'})">手动预警</li>
            <li :class="(parameterType.warningType.val.indexOf('2') > -1) ? 'hover' : ''" @click="multipleChoice({type:'warningType',val:'2',info:'专题预警 '})">专题预警 </li>
            <li :class="(parameterType.warningType.val.indexOf('1') > -1) ? 'hover' : ''" @click="multipleChoice({type:'warningType',val:'1',info:'公共预警'})">公共预警</li>
            <li :class="(parameterType.warningType.val.indexOf('5') > -1) ? 'hover' : ''" @click="multipleChoice({type:'warningType',val:'5',info:'人工预警'})">人工预警</li>
          </ul>
          <div class="clearfix"></div>
          <p class="pub_tit">摘要（单选）</p>
          <ul class="pub_Ul">
            <li :class="parameterType.abstract.val ? 'hover' : ''"  @click="radioChoice({type:'abstract',val:true,info:'显示'})">显示</li>
            <li :class="parameterType.abstract.val ? '' : 'hover'"  @click="radioChoice({type:'abstract',val:false,info:'不显示'})">不显示</li>
          </ul>
          <div class="clearfix"></div>
          <p class="pub_tit">图片识别（单选）</p>
          <ul class="pub_Ul">
            <li :class="(parameterType.isOcr.val == '') ? 'hover' : ''" @click="radioChoice({type:'isOcr',val:'',info:'全部'})">全部</li>
            <li :class="(parameterType.isOcr.val.indexOf('1') > -1) ? 'hover' : ''" @click="radioChoice({type:'isOcr',val:'1',info:'图片识别'})">图片识别</li>
            <li :class="(parameterType.isOcr.val.indexOf('0') > -1) ? 'hover' : ''" @click="radioChoice({type:'isOcr',val:'0',info:'非图片识别'})">非图片识别</li>
          </ul>
          <div class="clearfix"></div>
          <div class="button_warys">
            <span @click="resetInfo({type:'screen'})">重置</span>
            <span @click="screenList({type:'screen',val:'',info:''})">确定</span>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="getList">
      <!--研判列表-->
      <div class="pubWary clearfix" v-for="(item,i) of listData" :key="i" @click="judgmentDetail($event,item)">
        <!--新闻标题-->
        <div class="newTitle flex">
          <!-- 预警级别 -->
          <warningLevel 
            v-if="CONSTANT.WARNING_LEVEL.includes(item.warningClass)"
            :warning-level="item.warningClass"
            :warning-time-array="item.warningTimeArray"
            class-name="level-push-warning-list"
            @click.stop="warninglevelClick"
        ></warningLevel>
          <!--<router-link tag="a" :to="{path: 'pushwarningdetail', query: { uuid : item.uuid,simhash:item.simhash,infoid:item.infoId}}">{{item.title}}</router-link>-->
          <a v-html="item.title"></a>
        </div>
        <!--摘要-->
        <div class="abstract" v-show="abstractShow">
          <p v-html="item.abstracts"></p>
        </div>
        <!--小图标-->
        <div class="flex newInfo">
          <div class="flex_1 infos">
            <span class="qxx zheng" v-if="item.orientation == 1">正</span>
            <span class="qxx fu" v-else-if="item.orientation == 2">负</span>
            <span class="qxx zhong" v-else-if="item.orientation == 3">中</span>
            <span>{{item.timeZw}}</span>
            <span><a :href="item.url" @click.stop="tzUrl(item.url)">{{item.webname}}</a></span>
          </div>
          <div class="moreBotton" @click.stop="showMoreCz(i)">
            <div class="gnWary" :class="setgnWaryClass()" v-show="item.more_oper">
              <div class="div1">
                <div @click.stop="copyInfo(item)">
                  <i></i><p>复制信息</p>
                </div>
                <div @click.stop="copyInfo(item,k)" v-for="(co,k) of userCopyTemplate" :key="co.id">
                  <i></i><p>{{ co.templateName }}</p>
                </div>
              </div>
              <!--<div class="div2" @click.stop="deleteInfo(item)">-->
                <!--<i></i>-->
                <!--<p>删除</p>-->
              <!--</div>-->
              <i class="gnSj"></i>
            </div>
          </div>
        </div>
      </div>
      <!--研判列表end-->
    </van-list>
    <!--暂无数据-->
    <div class="nodata" v-show="finished && listData.length == 0">
      <p></p>
      <p>暂无数据</p>
    </div>
    </van-pull-refresh>
    <!--自定义时间-->
    <van-popup
      v-model="timePopup"
      position="bottom"
    >
      <!--开始时间-->
      <van-datetime-picker
        v-model="bTime"
        type="datetime"
        show-toolbar
        title="开始时间"
        confirm-button-text=" "
        cancel-button-text=" "
        :formatter="formatter"
        :visible-item-count = 3
        :max-date="maxDate"
      />
      <!--结束时间-->
      <van-datetime-picker
        v-model="eTime"
        type="datetime"
        title="结束时间"
        :visible-item-count = 3
        confirm-button-text=" "
        cancel-button-text=" "
        :formatter="formatter"
        :max-date="maxDate"
      />
      <div class="timeButton" @click="screenList({type:'zdytime',val:'',info:''})">完成</div>
    </van-popup>
  </div>
</template>
<script>
  let moment = require("moment");
  import { fetch } from "@/helpers/fetch"
  import { getUserCopy } from '@/api/wechat'
  import {handleClipboard} from '../../../assets/js/clipboard'
  import {deleteBatchWarning} from '@/api/judgment'
  import {getPushwarningList} from '@/api/pushwarning'
  import {DropdownMenu, DropdownItem, Dialog, Notify, List, Sticky,DatetimePicker,Popup,Toast,PullRefresh} from 'vant';
  import { wxShare } from '@/helpers/wxconfig'
  import { getSimpleText } from '@/helpers/util.js'
  import CONSTANTS from '@/helpers/constant'
  import warningLevel from '@/components/warningLevel/warningLevel' 
  import {getUserInfo} from '@/api/wechat' 
  export default {
    components: {
      "van-dropdown-menu": DropdownMenu,
      "van-dropdown-item": DropdownItem,
      "van-list": List,
      "van-sticky": Sticky,
      "van-datetime-picker": DatetimePicker,
      "van-popup": Popup,
      "van-pull-refresh": PullRefresh,
      "warningLevel":warningLevel
    },
    data() {
      return {
        copyArr:'',
        copyInfoTemplate:'',
        userCopyTemplate:[],
        isLoading_qj:false,
        finished_text:'',
        maxDate:new Date(),          //最大时间
        bTime:new Date(moment().format('l')),  //开始时间,默认 0时0分
        eTime:new Date(),          //结束时间
        timePopup:false,            //是否显示自定义时间
        listParameter: {
          sourceType: "",         //来源类型 逗号分隔
          orientation: "",        //倾向性 逗号分隔
          bTime: "",              //开始时间
          eTime: "",              //结束时间
          time: "24hour",               //时间 eg:7day 7天； 24hour 24小时
          warningType:"",       //预警级别
          isRead: "",             // 0未读 1已读
          isOcr: "",              // 是否仅看图片识别 0否 1是
          pageSize: "10",         // 每页条数
          pageNum: "0",           //页码
        },
        listData: [],             //类别数据
        sourceType:[],           //媒体类型数据
        loading: false,          //暂停加载数据
        finished: false,         //终止加载数据
        load: true,              //用于判断是否加载中
        abstractShow:true,       //是否显示摘要
        CONSTANT:{
        ...CONSTANTS
        },
        parameterType:{          //参数控制
          time:{
            val:'24hour',
            info:"24小时"
          },               //时间
          sourceType:{
            val:'',
            info:""
          },         //媒体类型
          isOcr:{
            val:'',
            info:''
          },              //是否仅看图片识别 0否 1是
          warningType:{
            val:"",
            info:""
          },       //预警级别
          abstract:{
            val:true,
            info:""
          }  //摘要
        },
        userInfo:''
      }
    },
    methods: {
      //获得用户信息
      getUserData(){
        getUserInfo().then(res=>{ 
          let {data,code} = res.data
          if(code === 200){
            this.userInfo = data
          }  
        })
      },
      tzUrl(url){
        window.location = url;
      },
      warninglevelClick(e){
        console.log(e)
      },
      setgnWaryClass(){
        let className = ''
        if(this.userCopyTemplate && this.userCopyTemplate.length === 1){
          className = 'gnWary1'
        }
        if(this.userCopyTemplate && this.userCopyTemplate.length === 2){
          className = 'gnWary2'
        }
        return className
      },
      //跳转详情页
      judgmentDetail(e,item){
        let names = e && e.target && e.target.className || ''
        if(names.indexOf('van-popup-class') > -1){
          //不做处理
        }else{
           this.$router.push({path: 'pushwarningdetail', query: {uuid : item.uuid,simhash:item.simhash,infoid:item.infoId,openid:this.$store.state.userInfo.openid}});
        }
      },
      //下拉加载
      onRefresh(){
        this.getList("screen");
      },
      //自定义时间弹层
      showZdytime(){
        this.$refs.item_time.toggle();
        this.timePopup = true;
      },
      //时间过滤
      formatter(type, value){
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        } else if (type === 'day') {
          return `${value}日`
        } else if (type === 'hour') {
          return `${value}时`
        } else if (type === 'minute') {
          return `${value}分`
        }
        return value;
      },
      //关闭弹层
      colseLayer() {
        this.more_oper = false;
        for (let i in this.listData) {
          this.listData[i].more_oper = false;
        }
      },
      //显示更多操作 复制  删除
      showMoreCz(i) {
        this.colseLayer();
        this.listData[i].more_oper = true;
      },
      getKeyValue(id,name,itemdata){
      let content = '';
      let tendency = '';
      let mediaTypeName = ''
      const authType = itemdata.authType + '' || ''
      if(itemdata.orientation == 1) {
        tendency = '正面';
      }else if(itemdata.orientation == 2) {
        tendency = '负面';
      }else if(itemdata.orientation == 3) {
        tendency = '中性';
      }
      switch(id) {
        case "1":
            content =  name + getSimpleText(itemdata.copyTitle);
            break;
        case "2":
            content = name + itemdata.url;
            break;
        case "3":
            content = name + getSimpleText(itemdata.copyAbstracts).getAbstract();
            break;
        case "4":
          var times =  moment(itemdata.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm')
            content = name + times;
            break;
        case "5":
            content = name + itemdata.webname;
            break;
        case "6":
            content = name + itemdata.author;
            break;
        case "7":
            content = name + tendency;
            break;
        case "8":
            // isComment: 是否评论，0：非评论 1：评论，评论时不显示评论数和转发数
            content = name + itemdata.replyNum;
            break;
        case "9":
            content = name + itemdata.forwardNum;
            break;
        case "10":
            content = name + itemdata.keyword;
            break;
        case '11' :
             if (authType === '3') {
                mediaTypeName = '蓝V'
              } else if (authType === '2') {
                mediaTypeName = '橙V'
              } else if (authType === '4') {
                mediaTypeName = '金V'
              } else {
                mediaTypeName = '普通用户'
              }
              content = name + mediaTypeName;
            break;
        case '12' :
          content = name + (itemdata && itemdata.fansCount ? itemdata.fansCount : 0);
            break;
        case '13' : // 单位
          content = name + this.userInfo.unitName || '';
            break;
        case '14' : // 作者ID
          content = name + (itemdata && itemdata.authorSourceId ? itemdata.authorSourceId : '');
            break;
        case '15' : // 涉事省份
        var area = (itemdata.contentMentionRegionList && itemdata.contentMentionRegionList.length) ?  itemdata.contentMentionRegionList[0].split('-')[0] : ''
          content = name + area;
            break;
            case '16' : // 涉事地域 
          var region = this.getRegionData(itemdata)
          content = name + region;
          break;
        case '17' : // 日期
        // var copyPublishTimeStr =  moment(itemdata.publishTime, "YYYYMMDDHHmmss").format('M月D日') 
          var timeString = moment(itemdata.publishTime, "YYYYMMDDHHmmss").format('M月D日')
          if (itemdata.copyPublishTime) {
            timeString = moment(itemdata.copyPublishTime, "YYYYMMDDHHmmss").format('M月D日')
          } 
          content = name + timeString;
          break;
        case '18' : // 抖音号
          var authorUserAccountNum = itemdata.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum;
          break;
        case '19' : // 抖音号
           var authorUserAccountNum2 = itemdata.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum2;
          break;
        case '20' : // 抖音号
          if (itemdata.mediaSourceType + '' === '11') {
            var videoUrls = itemdata.videoUrls || ''
            content = name + videoUrls;
          }
          break;
        case '21' : // 签到地
          var postPlace = itemdata.postPlace || ''
          var newStr = postPlace.replace(/<[^>]*>/g, '')
          content = name + newStr;
          break;
        case '22' : // 阅读数
          var visitCount = itemdata.visitCount || 0
          content = name + visitCount;
          break;
        case '23' : // 点赞数
        var praiseCount = itemdata.praiseCount || 0
          content = name + praiseCount;
          break;  
       case '24' : // 标签 
          // var Tag = (itemdata.firstIndustryTag && itemdata.secondIndustryTag) ? itemdata.firstIndustryTag + '-' + itemdata.secondIndustryTag : (itemdata.firstIndustryTag) ? itemdata.firstIndustryTag : ''
          var Tag = ''
          if (itemdata.industryTags) {
            Tag = itemdata.industryTags.join('、')
          }
          content = name + Tag
          break; 
        case '25' : // 专题名称 
          var subjectName = itemdata.subjectName || ''
          content = name + subjectName
          break; 
        case '26' : // 专题分类名称
          var catelogName = itemdata.catelogName || ''
          content = name + catelogName
          break;     
        case '27' : // 信息发布地域
          var ipRegion = itemdata.ipRegion || ''
          content = name + ipRegion
          break;
        case '28' : // 小红书号
          var authorUserAccountNum1 = itemdata.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum1;
          break;
        case '29' : // 作者地域
          var authorCptLocation = (itemdata.authorCptLocation && itemdata.authorCptLocation.length) ? itemdata.authorCptLocation[0] : ''
          content = name + authorCptLocation;
          break;
          case '30' : // 文章类型
        var articleType = '原发'
          if (itemdata.microBlogType === 5) {
            // 弹幕
            articleType = '弹幕'
          }
          if ((itemdata.isCommentData === 1 || itemdata.microBlogType + '' === '4') && itemdata.originInfo) {
            // 评论
            articleType = '评论'
          }
          if (itemdata.microBlogType === 2  && itemdata.originInfo) {
            // 转发
            articleType = '转发'
          }
          if (itemdata.microBlogType === 3&& itemdata.originInfo) {
            //  回复并转发
            articleType = '转评'
          }
          content = name + articleType;
          break;
        case '31' : // AI摘要
           content = name + '';
           break;
        default:
          content = name;
            break;
      } 
      return content
    },
      async newCopyInfo(copyInfoTemplate,itemdata){
        const mediaSourceType = itemdata.mediaSourceType || ''
      const webName = itemdata.webname || ''
      const copyitemInfo = [...this.CONSTANT.COPYITEM]
      let aiSummary = itemdata.aiSummaryState === 1 ? itemdata.copyAbstracts : (itemdata.aiSummary || '') 
      if (copyInfoTemplate.indexOf('${aiAbstract}') > -1) {
        if (!aiSummary) {
          aiSummary = await this.getAiSummary(itemdata)
          console.log(aiSummary)
          itemdata.aiSummary = aiSummary || '-1'
        }
      }
      copyitemInfo.forEach(item=>{
        if (item.id === '20' && copyInfoTemplate.indexOf(item.replace) > -1){
          // 视频文件地址 并且包含
          if (mediaSourceType+'' === '11') {
            const s = this.getKeyValue(item.id, '', itemdata)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          }else{
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        } else if (item.id === '18' || item.id === '19' || item.id === '28') {
          // 抖音
          if ((item.id === '18' && webName === '抖音') || (item.id === '19' && webName === '快手') || (item.id === '28' && webName === '小红书')) {
            const s = this.getKeyValue(item.id, '', itemdata)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          } else {
            // 不是抖音
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        } else if (item.id === '31' && aiSummary){
          //AI摘要
           const rexp = new RegExp('\\' + item.replace, 'g')  
          const aiSummaryData = aiSummary === '-1' ? itemdata.copyAbstracts : aiSummary
          copyInfoTemplate = copyInfoTemplate.replace(rexp, aiSummaryData)
        }else {
          const s = this.getKeyValue(item.id, '', itemdata)
          const rexp = new RegExp('\\' + item.replace, 'g')
          copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
        }
        
      })
      return copyInfoTemplate
      },
      handleClipboardData(content){ 
        const clipboard = document.createElement('textarea')
        clipboard.value = content
        document.body.appendChild(clipboard)
        clipboard.select() // 选择对象
        document.execCommand('Copy', false, true) // 执行浏览器复制命令
        clipboard.remove()
        Notify({
          message: '复制成功',
          duration: 1000,
          color: "",
          className: "notifyNew",
          background: ''
        }); 
      },
      //复制信息
      copyInfo(item,index) {
        let _this = this;
        let content = '';
        if(this.copyInfoTemplate && this.copyInfoTemplate.length){
          //新复制模版
          let template = this.copyInfoTemplate
          if(index+'' === '0'|| index){
            template = this.userCopyTemplate[index] ? this.userCopyTemplate[index].template : template
          }
          this.newCopyInfo(template,item).then(res=>{ 
          this.handleClipboardData(res,item)
         })
          return false
        }else{
          this.copyArr.map(item=>{
            content += '\n' + this.getKeyValue(item.id,item.name,item) 
          })
        }
        handleClipboard(content, event, () => {
          Notify({
            message: '复制成功',
            duration: 1000,
            color: "",
            className: "notifyNew",
            background: ''
          });
          let params = {
            uuid: item.uuid,
            infoType: '4' //1 专题 、2预警、3舆情研判微信端 、4推送预警微信端
          }
          _this.$store.commit('saveCopyInfo',params);
        }, () => {
          Notify({
            message: '复制失败！',
            duration: 1000,
            color: "",
            className: "notifyErr",
            background: ''
          });
        })
      },
       //复制信息
       copyInfo1(item) {
        let _this = this;
        let content = "";
        let orientation = "";
        if (item.orientation == '1') {
          orientation = '正面';
        }
        if (item.orientation == '2') {
          orientation = '负面';
        }
        if (item.orientation == '3') {
          orientation = '中性';
        }
        const authType = item.authType + '' || ''
        let mediaTypeName = ''
        content = content + "标题：" + item.copyTitle + "\n";
        content = content + "涉及关键词：" + item.keyword + "\n";
        content = content + "链接：" + item.url + "\n";
        content = content + "摘要：" + item.copyAbstracts.getAbstract() + "\n";
        content = content + "时间：" + moment(item.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm:ss') + "\n";
        content = content + "来源：" + item.webname + "\n";
        content = content + "作者：" + item.author + "\n";
        content = content + "倾向性：" + orientation + "\n";
        content = content + "评论数：" + item.replyNum + "\n";
        content = content + "转发数：" + item.forwardNum + "\n";
        if (item.sourceType === '04') {
          if (authType === '3') {
            mediaTypeName = '蓝V'
          } else if (authType === '2') {
            mediaTypeName = '橙V'
          } else if (authType === '4') {
            mediaTypeName = '金V'
          } else {
            mediaTypeName = '普通用户'
          }
          content = content + "粉丝数：" + item.authorFansCount + "\n";
          content = content + "认证类型：" + mediaTypeName + "\n";
        }
        handleClipboard(content, event, () => {
          Notify({
            message: '复制成功',
            duration: 1000,
            color: "",
            className: "notifyNew",
            background: ''
          });
          let params = {
            uuid: item.uuid,
            infoType: '4' //1 专题 、2预警、3舆情研判微信端 、4推送预警微信端
          }
          _this.$store.commit('saveCopyInfo',params);
        }, () => {
          Notify({
            message: '复制失败！',
            duration: 1000,
            color: "",
            className: "notifyErr",
            background: ''
          });
        })
      },
      //删除信息
      deleteInfo(item) {
        Dialog.confirm({
          title: '删除信息',
          message: '确定删除该条信息？',
          confirmButtonText: '确定',
          confirmButtonColor: '#007EFF',
        }).then(()=> {
          let p = {
            ids:item.uuid
          };
          // on confirm
          deleteBatchWarning(p).then(res=>{
            if(res.data.result && res.data.result.data > 0){
              Notify({
                message: '删除成功',
                duration: 1000,
                color: "",
                className: "notifyNew",
                background: ''
              });
              this.getList("screen");
            }
          }).catch(err=>{
            Notify({
              message: '删除失败！',
              duration: 1000,
              color: "",
              className: "notifyErr",
              background: ''
            });
            console.log(err);
          });
        }).catch((e) => {
          // on cancel
          console.log(e);
        });
      },
      //获得列表信息
      getList(s) {
        if (this.load) {
          this.load = false;
          if(s == 'screen'){
            //筛选
            this.listParameter.pageNum = 1;
            this.finished = false;
            Toast.loading({
              duration: 0,       // 持续展示 toast
              mask: true,
              message: '加载中...'
            })
          }else{
            this.listParameter.pageNum = parseInt(this.listParameter.pageNum) + 1;
          }
          if(this.listParameter.warningType == ""){
            this.listParameter.warningType = "1,2,3,4,5";
          }
          getPushwarningList(this.listParameter).then(res => {
            Toast.clear();
            if (res.data.result.data && res.data.result.data.length > 0) {
              let listArray = res.data.result.data;
              if(s == 'screen'){
                this.listData = [];
              }
              let todata = moment().format('YYYYMMDD');
              for (let i in listArray) {
                let beforeMinute = moment(listArray[i].warningTime, "YYYYMMDDHHmmss").format('YYYYMMDD');

                if(todata == beforeMinute){
                  //今天
                  listArray[i].timeZw = "今日 "+moment(listArray[i].warningTime, "YYYYMMDDHHmmss").format('HH:mm');
                }else{
                  listArray[i].timeZw = moment(listArray[i].warningTime, "YYYYMMDDHHmmss").format('MM-DD HH:mm');
                }
                //添加操作判断
                listArray[i].more_oper = false;
                // 预警级别
                if (listArray[i].warningTimeArray && listArray[i].warningTimeArray.length) {
                  listArray[i].warningTimeArray = this.handleWarningTimeArray(listArray[i].warningTimeArray)
                }
                this.listData.push(listArray[i]);
              }
              if (listArray.length < 10) {
                this.finished = true;
              }
            } else {
              if(s == 'screen'){
                this.listData = [];
              }
              this.finished = true;
            }
            if( this.listData.length > 0 && this.finished){
              this.finished_text = "没有更多了"
            }else{
              this.finished_text = ""
            }
            // 加载状态结束
            this.isLoading_qj = false;
            this.loading = false;
            this.load = true;
            wxShare('推送预警','快来看看我分享的网站:推送预警');
          }).catch(err => {
            Toast.clear();
            this.finished = true;
            // 加载状态结束
            this.isLoading_qj = false;
            this.loading = false;
            this.load = true;
            console.log(err);
          });
        }
      },
      // 处理时间记录
      handleWarningTimeArray(arr) {
        const strtime = 'YYYY-MM-DD HH:mm'
        arr.forEach(item => {
          item.warningTimes = moment(item.time).format(strtime)
          item.text = (item.level) ? this.CONSTANT.WARNING_LEVEL_INFO[item.level].TEXT : '—'
          item.desc = item.desc ? item.desc : '—'
        })
        return arr
      },
      //单选
      radioChoice(m){
        this.parameterType[m.type].val = m.val;
        this.parameterType[m.type].info = m.info;
      },
      //多选
      multipleChoice(m){
        if(m.val != ''){
          if(this.parameterType[m.type].val.indexOf(m.val) == -1){
            let mval = this.parameterType[m.type].val;
            let minfo = this.parameterType[m.type].info;
            this.parameterType[m.type].val = (mval == "") ? m.val : mval+","+m.val;
            this.parameterType[m.type].info = (minfo == "") ? m.info : minfo+","+m.info;
          }else{
            let str = this.parameterType[m.type].val.split(",");
            let strNew = "";
            for(let i in str){
              if(str[i] != m.val){
                strNew = (strNew == "") ? str[i]:strNew+","+str[i];
              }
            }
            if(strNew.length > 0){
              this.parameterType[m.type].val = strNew;
            }else{
              this.parameterType[m.type].val = "";
            }
          }
        }else{
          this.parameterType[m.type].val = "";
        }
      },
      //筛选数据
      screenList(p){
        /*
        *  p
        *  type:
        *      time             时间
        *      screen             筛选
        *      sourceType       媒体类型
        *      zdytime          自定义时间
        *  val:值
        *  info:文字
        * */
        if(p.type=='time'){
          //时间
          this.listParameter[p.type] = p.val;
          this.parameterType[p.type].val = p.val;
          this.parameterType[p.type].info = p.info;
          this.listParameter.bTime = "";
          this.listParameter.eTime = "";
        }else if(p.type=='screen'){
          //筛选
          //摘要
          this.abstractShow = this.parameterType.abstract.val;
          //预警级别
          this.listParameter.warningType = this.parameterType.warningType.val;
          //图片识别
          this.listParameter.isOcr = this.parameterType.isOcr.val;
        }else if(p.type=='sourceType'){
          //媒体类型
          this.listParameter.sourceType =  this.parameterType.sourceType.val;
        }else if(p.type=='zdytime'){
          //媒体类型
          this.listParameter.bTime = moment(this.bTime).format("YYYYMMDDHHmmss");
          this.listParameter.eTime = moment(this.eTime).format("YYYYMMDDHHmmss");
          if(this.listParameter.bTime > this.listParameter.eTime){
            Toast('开始时间不能晚于结束时间！');
            return false;
          }
          this.listParameter.time = 'zdy';
          this.parameterType.time.val = 'zdy';
          this.parameterType.time.info =  moment(this.bTime).format("MM-DD")+" 至 "+moment(this.eTime).format("MM-DD");
        }
        this.load = true;
        if(p.type=='zdytime'){
          this.timePopup = false;
        }else{
          this.$refs["item_"+p.type].toggle();
        }
        this.getList('screen');
      },
      //重置
      resetInfo(m){
        /*
        * m.type:
        *    "item_time"            时间层
        *     "screen"                筛选
        *     "sourceType"     媒体类型
        * */
        if(m.type == 'sourceType'){
          this.parameterType.sourceType.val = '';
          this.parameterType.sourceType.info = '媒体类型';
        }else if(m.type == 'screen'){
          this.parameterType.warningType.val = '';
          this.parameterType.isOcr.val = '';
          this.parameterType.abstract.val = true;
        }
      },
      //监听关闭
      closeItem(m){
        /*
        * m.type:
        *    "item_time"            时间层
        *     "screen"                筛选
        *     "item_sourceType"     媒体类型
        * */
        if(m.type == 'item_sourceType'){
          let st = this.listParameter.sourceType;
          if(st.length == 0){
            //媒体类型
            this.parameterType.sourceType.val = '';
            this.parameterType.sourceType.info = '媒体类型';
          }else{
            this.parameterType.sourceType.val = st;
          }
        }else if(m.type == 'screen'){
          //筛选
          let wtlen = this.listParameter.warningType.length,
            judgedStates = this.$store.state.userInfo.judgedState;
          if((judgedStates!="1" && wtlen == 9) || (judgedStates =="1" && wtlen == 7)){
            this.parameterType.warningType.val = "";
          }else{
            this.parameterType.warningType.val = this.listParameter.warningType;
          }
          this.parameterType.isOcr.val = this.listParameter.isOcr;
          this.parameterType.abstract.val = this.abstractShow;
        }
      },
      getUserCopy() {
        let params = {
          openid: this.$store.state.userInfo.openid
        }
        const _this = this
        getUserCopy(params).then(function(res) {
          const {code,data} = res.data
          if (code === 200) {
            const {copyInfoTemplate,oldCopyInfoTemplate,userCopyTemplate} = data
            _this.copyArr = oldCopyInfoTemplate // 之前的 
            _this.copyInfoTemplate = copyInfoTemplate  //新的
            _this.userCopyTemplate = userCopyTemplate  //新的
          }
        }).catch(err => {
          console.log(err, '请求失败！');
        });
      },
      getRegionData(itemdata){
        const provinceName = this.userInfo.provinceName // 省name
        const cityName = this.userInfo.cityName // 市name
        const countryName = this.userInfo.countryName // 县name
        let strData = provinceName
        if (cityName) {
          strData = strData + '-' + cityName
        }
        if (countryName) {
          strData = strData + '-' + countryName
        }
        const cmr = itemdata.contentMentionRegionList || [] 
        if (cmr.includes(strData)) {
          return strData
        } else {
          return cmr.length ? cmr[0] : ''
        }
      },
      async getAiSummary(item) { 
        let times = moment(item.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm:ss') 
        const p = {
          'url': item.hasOwnProperty('infoUrl') && item.infoUrl ? item.infoUrl : item.url,
          'content': item.content ? item.content : item.abstracts ? item.abstracts : item.title,
          // 'publishTime': item._publishTime,
          'publishTime': Number(new Date(times).getTime()),
          'indexSuffix': item.indexSuffix,
          'dataType': item.dataType+'',
          'id': item.uuid,
          'index': item.index || null,
          'origin': 1
        }
        p.content = p.content.replace(/<[^>]*>/g, '');
        let data = {
          url: '/api/wechat/summary/ai',
          method: 'post',
          data: p
        } 
        var res = await fetch(data)  
        let refData = res.data || ""
        if (refData && refData.code === 200) {
          item.summary = refData.data.aiSummary 
          return refData.data.aiSummary || '-1'
        } else {
          return '-1'
        }
      }
    },
    mounted() {
      let query = this.$route.query;
      let openid = query.openid;
      console.log(openid);
      // this.getList();
      this.getUserData();
      this.getUserCopy();
      if(this.$store.state.sourceType.sourcetype.length == 0){
        this.$store.dispatch("getAllSourceType").then(()=>{
          this.sourceType = this.$store.state.sourceType.sourcetype
        }).catch(()=>{
        });
      }else{
        this.sourceType = this.$store.state.sourceType.sourcetype
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../../judgment/list/list.css");
</style>
